import React, { useState, useEffect } from 'react';
import { useRemoteComponentStore } from '../context/RemoteComponentStoreContext';
import { Box, Typography } from '@mui/material';

const LastRefreshedTimeInfo: React.FC = () => {
    const { getSharedState, subscribe } = useRemoteComponentStore();
    const [, forceUpdate] = useState(0);

    // Force re-render when refresh info updates
    useEffect(() => {
        const unsubscribe = subscribe('refreshInfo', () => {
            forceUpdate(prev => prev + 1);
        });

        return unsubscribe;
    }, [subscribe]);

    // Get all refresh info from different products
    const getAllRefreshInfo = () => {
        // Get all keys from the internal store by checking with empty string
        const allData = getSharedState('') || {};
        const allKeys = Object.keys(allData);
        const refreshKeys = allKeys.filter(key => key.includes(':refreshInfo'));

        return refreshKeys.map(key => {
            const refreshInfo = getSharedState(key);
            const productName = key.split(':')[0];
            return {
                ...refreshInfo,
                product: productName,
                key
            };
        }).filter(info => info.timestamp);
    };

    const refreshInfoList = getAllRefreshInfo();

    if (refreshInfoList.length === 0) {
        return null;
    }

    // Get the most recent refresh info
    const latestRefresh = refreshInfoList.reduce((latest, current) => {
        if (!latest || new Date(current.timestamp) > new Date(latest.timestamp)) {
            return current;
        }
        return latest;
    }, null);

    const formatTime = (timestamp: string) => {
        const date = new Date(timestamp);
        const options: Intl.DateTimeFormatOptions = {
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
            timeZoneName: 'short'
        };

        const formatted = date.toLocaleString('en-US', options);
        return `Updated ${formatted}`;
    };

    return (
        <Box sx={{ padding: 1 }}>
            <Typography variant="caption" color="textSecondary">
                {formatTime(latestRefresh.timestamp)}
                {latestRefresh.status === 'loading' && ' - Refreshing...'}
            </Typography>
            {refreshInfoList.length > 1 && (
                <Typography variant="caption" color="textSecondary" sx={{ ml: 2 }}>
                    {refreshInfoList.length} sources active
                </Typography>
            )}
        </Box>
    );
};

export default LastRefreshedTimeInfo;